module.exports = __webpack_public_path__ + "static/media/display.20425df2.svg";